import React from 'react';
import { View, StyleSheet, Image } from '@react-pdf/renderer';
import InvoiceTableRow from './InvoiceTableRow';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 36,
        fontSize: 9,
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },
    logo: {
        width: 74,
        height: 66,
        //marginLeft: 'auto',
        //marginRight: 'auto'
    }
  });
 

  const SignPatient = ({items, medicalId}) => (
    <View style={styles.tableContainer}>
        <Image style={styles.logo} src={"https://my-market-mompos-online.s3.amazonaws.com/medisas-resource/"+ medicalId +".jpg"} />
        <InvoiceTableRow items={items} separator={2}/>
    </View>
  );
  
  export default SignPatient